import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import NuDate from '../../../../Components/Utils/NuDate';
import FilesView from '../../../../Components/Utils/FilesView';
import axiosInstance from '../../../../Services/axiosCommon';

function ViewOfRelatableGrn() {
  const { grnProductViewId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState(location.state?.data || null);
  const [filePathList, setFilePathList] = useState([]);

  useEffect(() => {
    if (!location.state?.data && grnProductViewId) {
      axiosInstance
        .get(`/grn/${grnProductViewId}`)
        .then((res) => {
          setData(res.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [grnProductViewId, location.state]);

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments || []);
    }
  }, [data])
  const onClose = () => {
    navigate(-1);
  }

  if (!data) {
    return (
      <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
        <div className="animate-scale-in w-[90%] h-[90vh] bg-white py-4 px-6 rounded-md shadow-lg flex items-center justify-center">
          <div className="flex flex-col items-center gap-2">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#579BB1]"></div>
            <p className="text-sm font-medium text-gray-500">Loading GRN details...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-2 sm:p-4">
      <div className="animate-scale-in w-full sm:w-[90%] max-w-[95vw] h-[90vh] bg-white py-4 px-3 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
        <div className='w-full flex justify-end mb-2'>
          <div className='w-5 h-5 rounded-sm flex justify-center items-center bg-red-400 text-white text-sm cursor-pointer' onClick={onClose}>X</div>
        </div>
        <div className="w-full mx-auto min-h-[calc(100vh-145px)] h-auto rounded-md overflow-hidden p-1 sm:p-2 flex gap-2 text-[#111537]">
          <div className="w-full bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden">
            <div className="w-[98%] bg-white px-2 mx-auto border border-gray py-2 rounded-lg flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 z-10">
              <div className="grid items-center">
                <div className="flex text-[14px] mb-1 text-[#111537] font-semibold">
                  <p className="">{data?.ref}</p>
                </div>
                <div className="flex gap-4">
                  <p className="text-xs text-[#111537]">Date : {data?.createdAt ? (
                    <NuDate value={data?.createdAt} format="DD-MMM-YYYY, hh:mm A" />
                  ) : (
                    "N/A"
                  )}
                  </p>
                </div>
              </div>

              <div className="grid gap-2 justify-end">
                <div className="border rounded-md mr-3 text-xs inline-flex w-auto flex-shrink-0 justify-center">
                  <p className="bg-white text-black p-1 rounded-l-md">
                    Status </p><p className="bg-[#579BB1] text-white p-1 items-center rounded-r-md"> {data?.status || 'None'}</p>
                </div>
              </div>
            </div>

            <div className="h-auto lg:h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8">
              <div className="w-full flex flex-wrap border border-gary mt-2 py-2 rounded-lg mb-2">
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-x-4 md:gap-x-8">
                  <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Delivery Notes</p>
                    <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.dnRef}</p>
                  </div>
                  <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Busy GRN No.</p>
                    <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.busyGrnNo}</p>
                  </div>

                  {data && (
                    <>
                      {data?.approvedByName && (
                        <div className='w-full flex px-2'>
                          <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Approved By</p>
                          <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.approvedByName}</p>
                        </div>
                      )}
                      {data?.reviewedByName && (
                        <div className='w-full flex px-2'>
                          <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Reviewed By</p>
                          <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.reviewedByName}</p>
                        </div>
                      )}
                      {data?.verifiedByName && (
                        <div className='w-full flex px-2'>
                          <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Verified By</p>
                          <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.verifiedByName}</p>
                        </div>
                      )}
                    </>
                  )}

                  <div className='w-full flex px-2'>
                    <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Comments</p>
                    <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.comments}</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mt-4">
                <div className="w-full sm:w-1/2">
                  <p className="text-xs font-medium text-[#111537] p-1">
                    GRN Attachments
                  </p>
                  <div className="border border-gary overflow-y-scroll h-28 rounded-lg p-2">
                    <div className="w-full flex gap-2 items-center flex-wrap">
                      {data?.attachments &&
                        filePathList.map((imgs, idx) => {
                          return (
                            <FilesView fileView={imgs} key={idx} />
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-full bg-white border border-gary mt-4 rounded-lg overflow-x-auto">
                <div className="min-w-[650px]">
                  <div className="w-full py-2 bg-baseColor-primary flex justify-between rounded-lg px-2">
                    <p className="w-[5%] text-left text-white text-xs font-medium">S.N. </p>
                    <p className="w-[40%] text-left text-white text-xs font-medium">Product</p>
                    <p className="w-[10%] text-center text-white text-xs font-medium">Unit</p>
                    <p className="w-[15%] text-center text-white text-xs font-medium">Ordered Qty</p>
                    <p className="w-[15%] text-center text-white text-xs font-medium">Received Qty</p>
                    <p className="w-[15%] text-center text-white text-xs font-medium">Remaining Qty</p>
                    <p className="w-[15%] text-center text-white text-xs font-medium">This Delivery</p>
                  </div>
                  {data?.products?.map((List, index) => {
                    return (
                      <div key={index} className="w-full py-2 flex justify-between odd:bg-white even:bg-slate-100 px-2">
                        <p className="w-[5%] text-left text-[#606279] text-xs font-light">
                          {index + 1}
                        </p>
                        <p className="w-[40%] text-left text-[#606279] text-xs font-light">
                          {List?.product_name}
                        </p>
                        <p className="w-[10%] text-center text-[#606279] text-xs font-light">
                          {List?.product_unit}
                        </p>
                        <p className="w-[15%] text-center text-[#606279] text-xs font-light">
                          {List?.orderedQty}
                        </p>
                        <p className="w-[15%] text-center text-[#606279] text-xs font-light">
                          {List?.receivedQty}
                        </p>
                        <p className="w-[15%] text-center text-[#606279] text-xs font-light">
                          {List?.remainingQty}
                        </p>
                        <p className="w-[15%] text-center text-[#606279] text-xs font-light">
                          {List?.thisDelivery}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewOfRelatableGrn